import { mapState, mapMutations, mapGetters } from "vuex";
import { LocaleMessage } from "vue-i18n";
// tools
import EventBus from "@/event-bus";
// mixins
import VueTypedMixin from "vue-typed-mixins";
import ButtonTextOn from "@/mixins/button-text-on";

export default VueTypedMixin(ButtonTextOn).extend({
  name: "mixin-navigation-bottom",
  mixins: [ButtonTextOn],
  props: {
    isUp: { type: Boolean, default: true },
    pTextOn: { type: Boolean, default: true },
  },
  data() {
    return {
      readAnnouncementNumber: this.$store.state.data.readAnnouncementNumber,
      gpsBtnStatus: "",
    };
  },
  computed: {
    ...mapState("data", ["hasCurrentLocation", "location", "gMaps"]),
    ...mapState("ui", ["showLoadingCard", "selectedCardHasSameBuilding"]),
    ...mapGetters("ui", ["isMap"]),
    /** @remarks handle GPS button */
    systemLang(): "ja" | "tw" | "cn" | "en" {
      if (this.$i18n.locale.includes("en")) {
        return "en";
      } else if (this.$i18n.locale.toLowerCase().includes("tw")) {
        return "tw";
      } else if (this.$i18n.locale.toLowerCase().includes("cn")) {
        return "cn";
      } else {
        return "ja";
      }
    },
    showActiveGPSBtn(): boolean {
      return (this.hasCurrentLocation === undefined || this.hasCurrentLocation) && this.gpsBtnStatus !== "loading";
    },
    showLoadingGPSBtn(): boolean {
      return this.gpsBtnStatus === "loading";
    },
    showDenyGPSBtn(): boolean {
      return this.hasCurrentLocation === false;
    },
    putToButtom(): boolean {
      return this.isListMode || this.isPlaceListNoData;
    },
    moveButtons() {
      if (!this.isUp && this.isMapMode && !this.isPlaceListNoData) return "move-down";
      else {
        if (this.isListMode || this.isPlaceListNoData) return "put-to-bottom";
        else if (this.selectedCardHasSameBuilding) return "move-up-same-building";
        else if (this.isUp && this.isMapMode && !this.isPlaceListNoData) return "move-up";
      }
    },
    isListMode(): boolean {
      return !this.isMapMode;
    },
    isMapMode(): boolean {
      return this.isMap;
    },
    isPlaceListNoData(): boolean {
      return this.$store.getters["data/isPlaceListNoData"] && !this.showLoadingCard;
    },
    isShowSwitchButton(): boolean {
      return !this.isPlaceListNoData || !this.isMapMode;
    },
    isShowGpsButton(): boolean {
      return this.isMap;
    },
    centerButtonTitle(): LocaleMessage {
      if (this.isMap) {
        return this.$t("Map.listTab");
      } else {
        return this.$t("Map.mapTab");
      }
    },
    isLandscape(): boolean {
      return this.$store.state.ui.deviceOrientation.orientation === "landscape" ? true : false;
    },
  },
  created() {
    this.watchUnreadAnnouncementNumber();
    this.watchHasCurrentLocation();
  },
  methods: {
    ...mapMutations("ui", ["setShowDenyGpsAlertView", "showMenuPanel"]),
    menuBtnClicked() {
      // GA, GTM tracking
      this.$gtag.event("click", {
        event_category: "Map item",
        event_label: "Menu avatar button",
        value: 1,
      });
      this.showMenuPanel(true);
    },

    watchUnreadAnnouncementNumber() {
      this.$watch(
        () => {
          return this.$store.state.data.readAnnouncementNumber;
        },
        (newVal: number) => {
          this.readAnnouncementNumber = newVal;
        },
      );
    },
    watchHasCurrentLocation() {
      this.$watch(
        () => {
          return this.hasCurrentLocation;
        },
        (newVal: boolean | undefined) => {
          this.gpsBtnStatus = newVal === undefined || newVal === true ? "" : "error";
        },
      );
    },
    toggleViewState() {
      const otherViewState = this.isMap ? "list" : "map";
      this.$store.commit("ui/setViewState", otherViewState);

      EventBus.$emit("change-gMap-in-action", false);
      EventBus.$emit("search-again", false);

      // GA, GTM tracking
      this.$gtag.event("click", {
        event_category: "Navigation item: Switch mode button",
        event_label: otherViewState,
        value: 1,
      });
    },
    /** @remarks handle GPS button */
    locationButtonnClicked() {
      this.$store.commit("data/setIsFirstLoadMap", false);
      EventBus.$emit("change-gMap-in-action", false);
      // GA, GTM tracking
      this.$gtag.event("click", {
        event_category: "Map item",
        event_label: "GPS button",
        value: 1,
      });
      console.log(`locationButtonnClicked hasCurrentLocation = ${this.hasCurrentLocation}`);
      if (this.hasCurrentLocation === undefined) {
        this.gpsBtnStatus = "loading";
        this.checkGPSLocationAtFirstTime();
        this.showSearchButton();
      } else if (this.hasCurrentLocation === true) {
        this.showSearchButton();
        if (this.location?.lat !== undefined) {
          // move maps to current loation
          this.$emit("assign-current-location-icon");
          if (!this.gMaps) return;
          this.gMaps?.panTo(new google.maps.LatLng(this.location.lat, this.location.lng));
        } else {
          if (this.showActiveGPSBtn) {
            this.gpsBtnStatus = "loading";
            this.checkGPSLocationAtFirstTime();
          } else if (this.showDenyGPSBtn) {
            this.setShowDenyGpsAlertView(true);
          }
        }
      } else if (this.hasCurrentLocation === false) {
        this.setShowDenyGpsAlertView(true);
      }
    },
    showSearchButton() {
      setTimeout(() => {
        EventBus.$emit("search-again", true);
      }, 100);
    },
    checkGPSLocationAtFirstTime() {
      if (this.hasCurrentLocation === false) {
        return console.error(`location grant was deny`);
      }
      this.$store.dispatch("data/checkGeolocation");
    },
  },
});
